








































import {forEach, isEmpty, isUndefined, PlainObject} from '@labor-digital/helferlein';

export default {
    name: 'BaseTextArea',
    props: {
        /**
         * set label for input field or use default slot
         * css class: inputField__label
         */
        label: {
            type: String
        },
        /**
         * set rows for the textarea to determine the initial height
         */
        rows: {
            default: 6,
            type: Number
        },
        /**
         * set error message in span
         * css class: inputField__error
         */
        error: {
            type: String
        },
        /**
         * set input as disabled and removes it from the form submission
         */
        placeholder: {
            type: String
        },
        /**
         * set input as required
         */
        required: {
            default: false,
            type: Boolean
        },
        /**
         * set input as read-only
         */
        readOnly: {
            default: false,
            type: Boolean
        },
        /**
         * set input as disabled
         */
        disabled: {
            default: false,
            type: Boolean
        },
        value: String
    },
    computed: {
        filteredAttributes(): PlainObject
        {
            const allowedAttrs = [
                'accept', 'alt', 'autofocus', 'autocomplete', 'form', 'formaction',
                'list', 'maxlength', 'minlength', 'size'
            ];
            const result = {};
            forEach(allowedAttrs, (attr) => {
                if (this.$attrs[attr]) {
                    result[attr] = this.$attrs[attr];
                }
            });
            return result;
        },
        valueInternal: {
            get()
            {
                return this.value;
            }, set(v)
            {
                this.$emit('input', v);
            }
        },
        hasLabel(): boolean
        {
            return !isEmpty(this.$slots.default) || !isEmpty(this.label);
        },
        classes(): Object
        {
            return {
                'textArea__input--required': this.required,
                'textArea__input--disabled': this.disabled,
                'textArea__input--readonly': this.readOnly,
                'textArea__input--error': this.error !== '' && !isUndefined(this.error)
            };
        }
    }
};
